import { Moment } from 'moment';

export type FilterQueryObject = {
	ids?: number[];
	by_title_ids?: number[];
	task_ids?: number[];
	team_ids?: number[];
	driver_ids?: number[];
	status?: Status;
	date?: string;
};

export type InitialFilterQueryObject = Omit<FilterQueryObject, 'date'> & { date?: Moment };

export enum Status {
	close = 'close',
	open = 'open'
}

export enum FilterBarListItemKeys {
	IDS = 'ids',
	TITLE = 'by_title_ids',
	STATUS = 'status',
	TASKS = 'task_ids',
	TEAMS = 'team_ids',
	DRIVERS = 'driver_ids',
	DATE = 'date'
}
